"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _underscore = require("underscore");

var _jquery = require("jquery");

var _Mixen2 = _interopRequireDefault(require("Mixen"));

var _Backbone = _interopRequireDefault(require("Backbone"));

var _hubspotReagan = _interopRequireDefault(require("hubspot.reagan.mixer"));

var _hubspotErrorPageMixer = _interopRequireDefault(require("hubspot.ErrorPageMixer.mixer"));

var _links = _interopRequireDefault(require("crm_internal/config/links"));

var _RouterContainer = _interopRequireDefault(require("crm_internal/containers/RouterContainer"));

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var _localSettings = _interopRequireDefault(require("crm_internal/config/localSettings"));

var _PropertyValidations = require("customer-data-properties/validation/PropertyValidations");

var _SettingsAPI = require("crm_data/settings/SettingsAPI");

var _PortalSettingsKeys = require("crm_data/constants/PortalSettingsKeys");

var _PageTypes = require("customer-data-objects/view/PageTypes");

var _connectPromiseSingle = require("crm_data/flux/connectPromiseSingle");

var _UserSettingsStore = _interopRequireDefault(require("crm_data/settings/UserSettingsStore"));

var _UserSettingsKeys = _interopRequireDefault(require("crm_data/settings/UserSettingsKeys"));

var _ScopesContainer = _interopRequireDefault(require("crm_internal/containers/ScopesContainer"));

var _AsyncComponentErrorHandler = _interopRequireDefault(require("crm_ui/utils/AsyncComponentErrorHandler"));

var renderAsyncRoute = function renderAsyncRoute(routeName) {
  for (var _len = arguments.length, props = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    props[_key - 1] = arguments[_key];
  }

  return [function (route) {
    var _route$default;

    return (_route$default = route.default).render.apply(_route$default, props);
  }, (0, _AsyncComponentErrorHandler.default)(routeName)];
};

var Router =
/*#__PURE__*/
function (_Mixen) {
  (0, _inherits2.default)(Router, _Mixen);

  function Router() {
    (0, _classCallCheck2.default)(this, Router);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Router).apply(this, arguments));
  }

  (0, _createClass2.default)(Router, [{
    key: "refreshPage",
    value: function refreshPage() {
      window.location.reload();
    }
  }, {
    key: "error",
    value: function error(code, ctx) {
      if (ctx == null) {
        ctx = {};
      }

      this.showErrorPage(code);
      console.error(code, 'router error', ctx); // eslint-disable-line no-console
    }
  }, {
    key: "propertyEditor",
    value: function propertyEditor(objectType, subjectId, query) {
      var _ref;

      return (_ref = import(
      /* webpackChunkName: "routes-PropertyEditorRoute" */
      'crm_ui/routes/PropertyEditorRoute')).then.apply(_ref, (0, _toConsumableArray2.default)(renderAsyncRoute('properties', objectType, subjectId, query && query.search)));
    }
  }, {
    key: "propertyEditorCompany",
    value: function propertyEditorCompany(subjectId, query) {
      return this.propertyEditor(_ObjectTypes.COMPANY, subjectId, query);
    }
  }, {
    key: "propertyEditorContact",
    value: function propertyEditorContact(subjectId, query) {
      return this.propertyEditor(_ObjectTypes.CONTACT, subjectId, query);
    }
  }, {
    key: "propertyEditorDeal",
    value: function propertyEditorDeal(subjectId, query) {
      return this.propertyEditor(_ObjectTypes.DEAL, subjectId, query);
    }
  }, {
    key: "propertyEditorTicket",
    value: function propertyEditorTicket(subjectId, query) {
      return this.propertyEditor(_ObjectTypes.TICKET, subjectId, query);
    }
  }, {
    key: "dealLineItemEditor",
    value: function dealLineItemEditor(subjectId) {
      var _ref2;

      return (_ref2 = import(
      /* webpackChunkName: "deal-line-item-editor-route" */
      'crm_ui/routes/DealLineItemEditorRoute')).then.apply(_ref2, (0, _toConsumableArray2.default)(renderAsyncRoute('deal-line-item-editor-route', _ObjectTypes.DEAL, subjectId)));
    }
  }, {
    key: "propertyHistory",
    value: function propertyHistory(objectType, subjectId, propertyName, query) {
      var _ref3;

      return (_ref3 = import(
      /* webpackChunkName: "routes-PropertyHistoryRoute" */
      'crm_ui/routes/PropertyHistoryRoute')).then.apply(_ref3, (0, _toConsumableArray2.default)(renderAsyncRoute('properties', objectType, subjectId, propertyName, query && query.search)));
    }
  }, {
    key: "propertyHistoryCompany",
    value: function propertyHistoryCompany(subjectId, propertyName, query) {
      return this.propertyHistory(_ObjectTypes.COMPANY, subjectId, propertyName, query);
    }
  }, {
    key: "propertyHistoryContact",
    value: function propertyHistoryContact(subjectId, propertyName, query) {
      return this.propertyHistory(_ObjectTypes.CONTACT, subjectId, propertyName, query);
    }
  }, {
    key: "start",
    value: function start() {
      var _this = this;

      var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var email = args.email;

      if (!email) {
        return this.contactsIndex();
      }

      return (0, _SettingsAPI.fetch)(_hubspot.default.get()).then(function (results) {
        try {
          var _JSON$parse = JSON.parse(results.get(_PortalSettingsKeys.ATMENTION_USER_INVITE_MAP + ":" + email)),
              objectId = _JSON$parse.objectId,
              objectType = _JSON$parse.objectType;

          return _this.profileRoute(objectType, objectId, {});
        } catch (error) {
          return _this.contactsIndex();
        }
      });
    }
  }, {
    key: "propertyHistoryDeal",
    value: function propertyHistoryDeal(subjectId, propertyName, query) {
      return this.propertyHistory(_ObjectTypes.DEAL, subjectId, propertyName, query);
    }
  }, {
    key: "propertyHistoryTicket",
    value: function propertyHistoryTicket(subjectId, propertyName, query) {
      return this.propertyHistory(_ObjectTypes.TICKET, subjectId, propertyName, query);
    }
  }, {
    key: "contactListMemberships",
    value: function contactListMemberships(subjectId, query) {
      var _ref4;

      return (_ref4 = import(
      /* webpackChunkName: "list-membership" */
      'crm_ui/routes/ContactListMembershipRoute')).then.apply(_ref4, (0, _toConsumableArray2.default)(renderAsyncRoute('list-membership', subjectId, query && query.search)));
    }
  }, {
    key: "contactWorkflows",
    value: function contactWorkflows(subjectId, query) {
      var _ref5;

      return (_ref5 = import(
      /* webpackChunkName: "contact-workflow-route" */
      'crm_ui/routes/ContactWorkflowRoute')).then.apply(_ref5, (0, _toConsumableArray2.default)(renderAsyncRoute('contact-workflow-route', subjectId, query && query.search)));
    }
  }, {
    key: "dashboard",
    value: function dashboard() {
      var url = document.location.origin + "/reports-dashboard/" + _hubspot.default.get() + "/sales";
      window.location = url;
      return url;
    }
  }, {
    key: "contactsSearchIndex",
    value: function contactsSearchIndex(filters) {
      return this.searchIndex(filters, _ObjectTypes.CONTACT);
    }
  }, {
    key: "companiesSearchIndex",
    value: function companiesSearchIndex(filters) {
      return this.searchIndex(filters, _ObjectTypes.COMPANY);
    }
  }, {
    key: "dealsSearchIndex",
    value: function dealsSearchIndex(filters) {
      return this.searchIndex(filters, _ObjectTypes.DEAL);
    }
  }, {
    key: "searchIndex",
    value: function searchIndex(filters, objectType) {
      var _ref6;

      if (objectType == null) {
        objectType = _ObjectTypes.CONTACT;
      }

      return (_ref6 = import(
      /* webpackChunkName: "search-index-route" */
      'crm_ui/routes/SearchIndexRoute')).then.apply(_ref6, (0, _toConsumableArray2.default)(renderAsyncRoute('search-index-route', filters, objectType)));
    }
  }, {
    key: "companiesIndex",
    value: function companiesIndex(viewId, query) {
      var _ref7;

      return (_ref7 = import(
      /* webpackChunkName: "companies-index-route" */
      'crm_ui/routes/CompaniesIndexRoute')).then.apply(_ref7, (0, _toConsumableArray2.default)(renderAsyncRoute('companies-index-route', viewId, query)));
    }
  }, {
    key: "contactsIndex",
    value: function contactsIndex(viewId, query) {
      var _ref8;

      return (_ref8 = import(
      /* webpackChunkName: "contacts-index-route" */
      'crm_ui/routes/ContactsIndexRoute')).then.apply(_ref8, (0, _toConsumableArray2.default)(renderAsyncRoute('contacts-index-route', viewId, query)));
    }
  }, {
    key: "ticketsIndex",
    value: function ticketsIndex(viewId, query) {
      var _ref9;

      if (!_ScopesContainer.default.getContainer().get()['tickets-access']) {
        return _RouterContainer.default.getContainer().get().navigate('/contacts', {
          trigger: true
        });
      }

      return (_ref9 = import(
      /* webpackChunkName: "tickets-index-route" */
      'crm_ui/routes/TicketsIndexRoute')).then.apply(_ref9, (0, _toConsumableArray2.default)(renderAsyncRoute('tickets-index-route', viewId, query)));
    }
  }, {
    key: "contactSampleRedirect",
    value: function contactSampleRedirect(tab, query) {
      var _ref10;

      return (_ref10 = import(
      /* webpackChunkName: "sample-contact-route" */
      'crm_ui/routes/SampleContactRoute')).then.apply(_ref10, (0, _toConsumableArray2.default)(renderAsyncRoute('sample-contact-route', tab, query)));
    }
  }, {
    key: "dealsIndex",
    value: function dealsIndex(viewId, query) {
      var _ref11;

      return (_ref11 = import(
      /* webpackChunkName: "deals-index" */
      'crm_ui/routes/DealsIndexRoute')).then.apply(_ref11, (0, _toConsumableArray2.default)(renderAsyncRoute('deals-index', viewId, query)));
    }
  }, {
    key: "templatesIndex",
    value: function templatesIndex(templateId, ownerId, query) {
      var url = _links.default.templates();

      templateId = templateId ? "/" + templateId : '';
      ownerId = ownerId ? "/" + ownerId : '';
      query = query ? "?" + (0, _jquery.param)(query) : '';
      return window.location = "" + url + templateId + ownerId + query;
    }
  }, {
    key: "dealsStages",
    value: function dealsStages() {
      var redirectPath = document.location.origin + "/sales-products-settings/" + _hubspot.default.get() + "/deals";
      return window.location = redirectPath;
    }
  }, {
    key: "queueTask",
    value: function queueTask(query) {
      var _ref12;

      return (_ref12 = import(
      /* webpackChunkName: "queue-task-route" */
      'crm_ui/routes/QueueTaskRoute')).then.apply(_ref12, (0, _toConsumableArray2.default)(renderAsyncRoute('queue-task-route', query)));
    }
  }, {
    key: "deals",
    value: function deals(viewId, query) {
      var _this2 = this;

      var name;

      var localViewType = _localSettings.default.get('deals.default');

      var renderDeals = function renderDeals(viewType) {
        if (viewType === _PageTypes.INDEX) {
          name = 'dealsIndex';

          _this2.dealsIndex(viewId, query);
        } else {
          name = 'dealsBoard';

          _this2.dealsBoard(viewId, query);
        }

        return (0, _underscore.defer)(function () {
          return _Backbone.default.history.trigger('route', _this2, name, [viewId, query]);
        });
      };

      if (localViewType) {
        renderDeals(localViewType);
      } else {
        (0, _connectPromiseSingle.connectPromiseSingle)({
          stores: [_UserSettingsStore.default],
          deref: function deref() {
            return _UserSettingsStore.default.get(_UserSettingsKeys.default.DEAL_VIEWTYPE_DEFAULT);
          }
        })().then(function (result) {
          renderDeals(result);
        }).catch(function () {
          return renderDeals(_PageTypes.BOARD);
        });
      }
    }
  }, {
    key: "dealsBoard",
    value: function dealsBoard(viewId, query) {
      var _ref13;

      return (_ref13 = import(
      /* webpackChunkName: "deals-board-route" */
      'crm_ui/routes/DealsBoardRoute')).then.apply(_ref13, (0, _toConsumableArray2.default)(renderAsyncRoute('deals-board-route', viewId, query)));
    }
  }, {
    key: "tickets",
    value: function tickets(viewId, query) {
      var _this3 = this;

      if (!_ScopesContainer.default.getContainer().get()['tickets-access']) {
        return _RouterContainer.default.getContainer().get().navigate('/contacts', {
          trigger: true
        });
      }

      var name;

      var localViewType = _localSettings.default.get('tickets.default');

      var renderTickets = function renderTickets(viewType) {
        if (viewType === _PageTypes.BOARD) {
          name = 'ticketsBoard';

          _this3.ticketsBoard(viewId, query);
        } else {
          name = 'ticketsIndex';

          _this3.ticketsIndex(viewId, query);
        }

        return (0, _underscore.defer)(function () {
          return _Backbone.default.history.trigger('route', _this3, name, [viewId, query]);
        });
      };

      if (localViewType) {
        renderTickets(localViewType);
      } else {
        (0, _connectPromiseSingle.connectPromiseSingle)({
          stores: [_UserSettingsStore.default],
          deref: function deref() {
            return _UserSettingsStore.default.get(_UserSettingsKeys.default.TICKET_VIEWTYPE_DEFAULT);
          }
        })().then(function (result) {
          renderTickets(result);
        }).catch(function () {
          return renderTickets(_PageTypes.INDEX);
        });
      }

      return null;
    }
  }, {
    key: "ticketsBoard",
    value: function ticketsBoard(viewId, query) {
      var _ref14;

      if (!_ScopesContainer.default.getContainer().get()['tickets-access']) {
        return _RouterContainer.default.getContainer().get().navigate('/contacts', {
          trigger: true
        });
      }

      return (_ref14 = import(
      /* webpackChunkName: "tickets-board-route" */
      'crm_ui/routes/TicketsBoardRoute')).then.apply(_ref14, (0, _toConsumableArray2.default)(renderAsyncRoute('tickets-board-route', viewId, query)));
    }
  }, {
    key: "redirectToTasks",
    value: function redirectToTasks() {
      return _RouterContainer.default.getContainer().get().navigate('tasks', {
        trigger: true,
        replace: true
      });
    }
  }, {
    key: "contactProfileEmail",
    value: function contactProfileEmail(email, query) {
      var _ref15;

      return (_ref15 = import(
      /* webpackChunkName: "profile-email-route" */
      'crm_ui/routes/ContactProfileEmailRoute')).then.apply(_ref15, (0, _toConsumableArray2.default)(renderAsyncRoute('profile-email-route', email, query)));
    }
  }, {
    key: "oldContactProfile",
    value: function oldContactProfile(id) {
      return _RouterContainer.default.getContainer().get().navigate("/contact/" + id, {
        trigger: true,
        replace: true
      });
    }
  }, {
    key: "retiredPlaylist",
    value: function retiredPlaylist(id) {
      return this.contactProfile(id.currentContactId);
    }
  }, {
    key: "profileRoute",
    value: function profileRoute(objectType, id, query) {
      var _ref16;

      return (_ref16 = import(
      /* webpackChunkName: "profile-route" */

      /* webpackPrefetch: true */
      'crm_ui/routes/ProfileRoute')).then.apply(_ref16, (0, _toConsumableArray2.default)(renderAsyncRoute('profile-route', objectType, id, query)));
    }
  }, {
    key: "contactProfile",
    value: function contactProfile(id, query) {
      if (query == null) {
        query = {};
      }

      if ((0, _PropertyValidations.isValidEmail)(id)) {
        this.contactProfileEmail(id, query);
        return null;
      }

      return this.profileRoute(_ObjectTypes.CONTACT, id, query);
    }
  }, {
    key: "companyProfile",
    value: function companyProfile(id, query) {
      if (query == null) {
        query = {};
      }

      return this.profileRoute(_ObjectTypes.COMPANY, id, query);
    }
  }, {
    key: "dealProfile",
    value: function dealProfile(id, query) {
      if (query == null) {
        query = {};
      }

      return this.profileRoute(_ObjectTypes.DEAL, id, query);
    }
  }, {
    key: "ticketProfile",
    value: function ticketProfile(id, query) {
      if (!_ScopesContainer.default.getContainer().get()['tickets-access']) {
        return _RouterContainer.default.getContainer().get().navigate('/contacts', {
          trigger: true
        });
      }

      return this.profileRoute(_ObjectTypes.TICKET, id, query);
    }
  }, {
    key: "quoteLanding",
    value: function quoteLanding(quoteId) {
      var _ref17;

      return (_ref17 = import(
      /* webpackChunkName: "quote-route" */
      'crm_ui/routes/QuoteRoute')).then.apply(_ref17, (0, _toConsumableArray2.default)(renderAsyncRoute('quote-route', quoteId)));
    }
  }, {
    key: "settings",
    value: function settings(section) {
      var salesSettingsPath = document.location.origin + "/sales-products-settings/" + _hubspot.default.get() + "/";

      if (section != null) {
        salesSettingsPath += section;
      }

      return window.location = salesSettingsPath;
    }
  }, {
    key: "salesNavigator",
    value: function salesNavigator(objectType, subjectId) {
      var _ref18;

      return (_ref18 = import(
      /* webpackChunkName: "sales-navigator-route" */
      'crm_ui/routes/LinkedInSalesNavigatorRoute')).then.apply(_ref18, (0, _toConsumableArray2.default)(renderAsyncRoute('sales-navigator-route', objectType, subjectId)));
    }
  }, {
    key: "contactTimelineEmbed",
    value: function contactTimelineEmbed(id, query) {
      var _ref19;

      if (query == null) {
        query = {};
      }

      return (_ref19 = import(
      /* webpackChunkName: "contact-timeline-embed-app" */
      'crm_ui/routes/ContactTimelineEmbedRoute')).then.apply(_ref19, (0, _toConsumableArray2.default)(renderAsyncRoute(id, query)));
    }
  }, {
    key: "companySalesNavigator",
    value: function companySalesNavigator(subjectId) {
      return this.salesNavigator(_ObjectTypes.COMPANY, subjectId);
    }
  }, {
    key: "contactSalesNavigator",
    value: function contactSalesNavigator(subjectId) {
      return this.salesNavigator(_ObjectTypes.CONTACT, subjectId);
    }
  }, {
    key: "tempEmail",
    value: function tempEmail(objectType, subjectId, engagementId) {
      var _ref20;

      return (_ref20 = import(
      /* webpackChunkName: "temp-email-route" */
      'crm_ui/routes/TempEmailRoute')).then.apply(_ref20, (0, _toConsumableArray2.default)(renderAsyncRoute('temp-email-route', {
        objectType: objectType,
        subjectId: subjectId,
        engagementId: engagementId
      })));
    }
  }], [{
    key: "initClass",
    value: function initClass() {
      this.prototype.routes = {
        '(/)': 'contactsIndex',
        'dashboard(/)': 'dashboard',
        'dashboard/:ownerId(/)': 'dashboard',
        'start(/)': 'start',
        'settings(/:section)(/)': 'settings',
        'search/:filters(/)': 'searchIndex',
        'contacts/search/:filters(/)': 'contactsSearchIndex',
        'companies/search/:filters(/)': 'companiesSearchIndex',
        'deals/search/:filters(/)': 'dealsSearchIndex',
        'contacts(/)': 'contactsIndex',
        'contacts/list(/)': 'contactsIndex',
        'contacts/list/view/:view(/)': 'contactsIndex',
        'contacts/view/:view(/)': 'contactsIndex',
        'contacts-test(/)': 'contactsIndex',
        'contacts-test/list(/)': 'contactsIndex',
        'contacts-test/list/view/:view(/)': 'contactsIndex',
        'contacts-test/view/:view(/)': 'contactsIndex',
        'companies(/)': 'companiesIndex',
        'companies/list(/)': 'companiesIndex',
        'companies/list/view/:view(/)': 'companiesIndex',
        'companies/view/:view(/)': 'companiesIndex',
        'companies-test(/)': 'companiesIndex',
        'companies-test/list(/)': 'companiesIndex',
        'companies-test/list/view/:view(/)': 'companiesIndex',
        'companies-test/view/:view(/)': 'companiesIndex',
        'tasks-queue(/)': 'queueTask',
        'tasks/view/:view(/)': 'refreshPage',
        'tasks/list(/)': 'refreshPage',
        'tasks/list/view/:view(/)': 'refreshPage',
        'tasks(/)': 'refreshPage',
        'tasks/board(/)': 'refreshPage',
        'tasks/board/view/:view(/)': 'refreshPage',
        'tasks/agenda(/)': 'refreshPage',
        'tasks/agenda/view/:view(/)': 'refreshPage',
        'tickets(/)': 'tickets',
        'tickets/view/:view(/)': 'ticketsIndex',
        'tickets/list(/)': 'ticketsIndex',
        'tickets/list/view/:view(/)': 'ticketsIndex',
        'tickets-test(/)': 'tickets',
        'tickets-test/view/:view(/)': 'ticketsIndex',
        'tickets-test/list(/)': 'ticketsIndex',
        'tickets-test/list/view/:view(/)': 'ticketsIndex',
        'tickets/board(/)': 'ticketsBoard',
        'tickets/board/view/:view(/)': 'ticketsBoard',
        'deals/view/:view(/)': 'dealsIndex',
        'deals/list(/)': 'dealsIndex',
        'deals/list/view/:view(/)': 'dealsIndex',
        'deals-test/view/:view(/)': 'dealsIndex',
        'deals-test/list(/)': 'dealsIndex',
        'deals-test/list/view/:view(/)': 'dealsIndex',
        'deals(/)': 'deals',
        'deals/board(/)': 'dealsBoard',
        'deals/board/view/:view(/)': 'dealsBoard',
        'deals/stages(/)': 'dealsStages',
        'companies/:companyId(/)': 'companyProfile',
        'deals/:dealId(/)': 'dealProfile',
        'tickets/:ticketId(/)': 'ticketProfile',
        'contact-sample/:tab(/)': 'contactSampleRedirect',
        'contact/email/:contactEmail(/)': 'contactProfileEmail',
        'contacts/:contactId(/)': 'contactProfile',
        'contact/:contactId/properties(/)': 'propertyEditorContact',
        'contact/:contactId/history(/)(:propertyName)(/)': 'propertyHistoryContact',
        'contact/:contactId/list-memberships(/)': 'contactListMemberships',
        'contact/:contactId/workflow-memberships(/)': 'contactWorkflows',
        'contact/:contactId/sales-navigator(/)': 'contactSalesNavigator',
        'contact/:contactId(/)': 'contactProfile',
        'contact-beta/:contactId/properties(/)': 'propertyEditorContact',
        'contact-beta/:contactId/history(/)(:propertyName)(/)': 'propertyHistoryContact',
        'contact-beta/:contactId/list-memberships(/)': 'contactListMemberships',
        'contact-beta/:contactId/workflow-memberships(/)': 'contactWorkflows',
        'contact-beta/:contactId/sales-navigator(/)': 'contactSalesNavigator',
        'contact-beta/:contactId(/)': 'contactProfile',
        'contact/:contactId(/)*path': 'oldContactProfile',
        'company/:companyId(/)': 'companyProfile',
        'company/:companyId/properties(/)': 'propertyEditorCompany',
        'company/:companyId/history(/)(:propertyName)(/)': 'propertyHistoryCompany',
        'company/:companyId/sales-navigator(/)': 'companySalesNavigator',
        'deal/:dealId(/)': 'dealProfile',
        'deal/:dealId/properties(/)': 'propertyEditorDeal',
        'deal/:dealId/history(/)(:propertyName)(/)': 'propertyHistoryDeal',
        'deal/:dealId/new(/)': 'dealProfile',
        'deal/:dealId/products(/)': 'dealLineItemEditor',
        'quote/:quoteId(/)': 'quoteLanding',
        'ticket/:ticketId(/)': 'ticketProfile',
        'ticket/:ticketId/properties(/)': 'propertyEditorTicket',
        'ticket/:ticketId/history(/)(:propertyName)(/)': 'propertyHistoryTicket',
        'lists(/)': 'refreshPage',
        'lists/create(/)': 'refreshPage',
        'lists/cleanup(/)': 'refreshPage',
        'lists/:listId(/)': 'refreshPage',
        'visits(/)': 'refreshPage',
        'visits/list(/)': 'refreshPage',
        'visits/list/view/:view(/)': 'refreshPage',
        'visits/view/:view(/)': 'refreshPage',
        'visits/welcome(/)': 'refreshPage',
        'embed/contact/:contactId(/)': 'contactTimelineEmbed',
        // temporary solve for large emails
        'email/:engagementId/:objectType/:subjectId': 'tempEmail',
        // Backwards compatible links
        'visits-beta/list/view/:viewId(/)': 'refreshPath',
        'prospects(/)(*path)': 'refreshPath',
        'visits-beta(/)(*path)': 'refreshPath',
        'news(/)(*path)': 'refreshPath',
        'playlist(/)': 'retiredPlaylist',
        'templates(/)(:templateId)(/:ownerId)(/)': 'templatesIndex'
      };
      this.prototype.tests = {
        contactsIndex: {
          table: '.contacts .data-grid .table, [data-reagan-test="data-table"], [data-reagan-test="empty-state"]'
        },
        companiesIndex: {
          table: '.companies .data-grid .table, [data-reagan-test="data-table"], [data-reagan-test="empty-state"]'
        },
        ticketsIndex: {
          table: '.tickets .data-grid .table, [data-reagan-test="data-table"], [data-reagan-test="empty-state"]'
        },
        dealsIndex: {
          table: '.deals .data-grid .table, [data-reagan-test="data-table"], [data-reagan-test="empty-state"]'
        },
        dealsBoard: {
          board: '.deals .board-column, [data-reagan-test="empty-state"]',
          boardItem: '.deals .board-column-list-item, [data-reagan-test="empty-state"]'
        },
        ticketsBoard: {
          board: '.tickets .board-column, [data-reagan-test="empty-state"]',
          boardItem: '.tickets .board-column-list-item, [data-reagan-test="empty-state"]'
        },
        companyProfile: {
          properties: '.companies [data-selenium-expanded="true"] [data-selenium-test="profile-properties"], ' + '.companies [data-selenium-expanded="false"][data-sidebar-key="Properties"], ' + '.companies [data-selenium-expanded="false"][data-sidebar-key="GLOBAL_PROPERTIES:0"], ' + '.companies .error-message[data-error="404"]',
          timeline: '.companies [data-reagan-success="timeline"], .error-message[data-error="404"]',
          interactions: '.companies [data-selenium-test="profile-interactions"], .profile-3-column, .error-message[data-error="404"]'
        },
        dealProfile: {
          properties: '.deals [data-selenium-expanded="true"] [data-selenium-test="profile-properties"], ' + '.deals [data-selenium-expanded="false"][data-sidebar-key="Properties"], ' + '.deals [data-selenium-expanded="false"][data-sidebar-key="GLOBAL_PROPERTIES:0"], ' + '.deals .error-message[data-error="404"]',
          timeline: '.deals [data-reagan-success="timeline"], .error-message[data-error="404"]',
          interactions: '.deals [data-selenium-test="profile-interactions"], .profile-3-column, .error-message[data-error="404"]'
        },
        contactProfile: {
          properties: '.contacts [data-selenium-expanded="true"] [data-selenium-test="profile-properties"], ' + '.contacts [data-selenium-expanded="false"][data-sidebar-key="Properties"], ' + '.contacts [data-selenium-expanded="false"][data-sidebar-key="GLOBAL_PROPERTIES:0"], ' + '.contacts .error-message[data-error="404"]',
          timeline: '.contacts [data-reagan-success="timeline"], .error-message[data-error="404"]',
          interactions: '.contacts [data-selenium-test="profile-interactions"], .profile-3-column, .error-message[data-error="404"]'
        },
        ticketProfile: {
          properties: '.tickets [data-selenium-expanded="true"] [data-selenium-test="profile-properties"], ' + '.tickets [data-selenium-expanded="false"][data-sidebar-key="Properties"], ' + '.tickets [data-selenium-expanded="false"][data-sidebar-key="GLOBAL_PROPERTIES:0"], ' + '.tickets .error-message[data-error="404"]',
          timeline: '.tickets [data-reagan-success="timeline"], .error-message[data-error="404"]',
          interactions: '.tickets [data-selenium-test="profile-interactions"], .profile-3-column, .error-message[data-error="404"]'
        },
        queueTask: {
          queueTaskTopbar: '[data-reagan-test="queue-topbar"]'
        },
        propertyEditorContact: {
          properties: '.PropertyEditorGroup',
          favorites: '.SidebarSelectPropertiesItem'
        },
        propertyEditorCompany: {
          properties: '.PropertyEditorGroup',
          favorites: '.SidebarSelectPropertiesItem'
        },
        propertyEditorDeal: {
          properties: '.PropertyEditorGroup',
          favorites: '.SidebarSelectPropertiesItem'
        },
        propertyEditorTicket: {
          properties: '.PropertyEditorGroup',
          favorites: '.SidebarSelectPropertiesItem'
        },
        propertyHistoryContact: {
          table: '.table'
        },
        propertyHistoryCompany: {
          table: '.table'
        },
        propertyHistoryDeal: {
          table: '.table'
        },
        propertyHistoryTicket: {
          table: '.table'
        },
        contactListMemberships: {
          table: '.table'
        },
        contactWorkflows: {
          table: '.table'
        },
        contactSalesNavigator: {
          iframe: '.sales-navigator-iframe'
        },
        companySalesNavigator: {
          iframe: '.sales-navigator-iframe'
        },
        dealLineItemEditor: {
          table: '.deal-line-item-editor-table, .deal-line-item-editor-zero-state'
        },
        // Redirect routes
        dashboard: {},
        deals: {},
        oldContactProfile: {},
        contactProfileEmail: {},
        start: {}
      };
      this.prototype.errorPageDefaults = {
        mainContainer: 'body .app',
        404: {
          link_href: "/contacts/" + _hubspot.default.get()
        },
        410: {
          link_href: "/contacts/" + _hubspot.default.get()
        }
      };
    }
  }]);
  return Router;
}((0, _Mixen2.default)(_hubspotErrorPageMixer.default, _hubspotReagan.default, _Backbone.default.Router));

Router.initClass();

var _default = new Router();

exports.default = _default;
module.exports = exports.default;